import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useIsMobile } from "@/hooks/use-mobile";

import { FormSheet, FormSheetBody, FormSheetHeader } from "../misc/FormSheet";

import type { Tag } from "../types";
import { TagForm } from "./TagForm";

type TagDialogProps = {
  open: boolean;
  tag?: Pick<Tag, "name" | "color">;
  title: string;
  onSubmit(tag: Pick<Tag, "name" | "color">): Promise<void>;
  onClose(): void;
};

export function TagDialog({
  open,
  tag,
  title,
  onClose,
  onSubmit,
}: TagDialogProps) {
  const handleClose = (isOpen = false) => {
    if (!isOpen) {
      onClose();
    }
  };

  const handleSubmit = async (data: Pick<Tag, "name" | "color">) => {
    await onSubmit(data);
    handleClose();
  };

  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <FormSheet open={open} onOpenChange={handleClose}>
        <FormSheetHeader title={title} />
        <FormSheetBody>
          <TagForm open={open} tag={tag} onSubmit={handleSubmit} />
        </FormSheetBody>
      </FormSheet>
    );
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <TagForm open={open} tag={tag} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
}
